import { useState } from "react";

export default function SmoothImg({ className = "", style, onLoad, ...props }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      {...props}
      decoding="async"
      onLoad={(e) => { setLoaded(true); onLoad?.(e); }}
      ref={(el) => { if (el?.complete && el.naturalWidth && !loaded) setLoaded(true); }}
      style={style}
      className={`${className} transition-[opacity,filter,transform] duration-300 ease-out ${loaded ? "opacity-100" : "opacity-0"}`}
    />
  );
}
